import React, {useCallback, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'
import OptService from '../core/_requests'
import {useLocation, Route, Routes} from 'react-router-dom'
import {AcceptTermUPicLayout} from './AcceptTermLayout'
import {Policy, PolicySource} from '../core/_const'
import {ActiveSuccess} from './ActiveSuccess'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {ActiveError} from './ActiveError'

const TermsAcceptComponent = () => {
  const intl = useIntl()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const token = params.get('token')
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [messageError, setMessageError] = useState('')

  const handleAccept = useCallback(async () => {
    try {
      setIsLoading(true)
      const payload = {
        token,
        policies: {
          [Policy.U_PIC]: true,
        },
        source: PolicySource.EMAIL,
      }
      const response = await OptService.acknowledgmentToken(payload)
      setIsLoading(false)
      if (!response.status) {
        setIsError(true)
      }
    } catch (error: any) {
      setIsLoading(false)
      setIsError(true)
      setMessageError(
        error?.response?.data?.error?.message ??
          intl.formatMessage({id: 'UPDATE_TERM_AND_POLICY_FALSE'})
      )
    }
  }, [intl, token])

  useEffect(() => {
    handleAccept()
  }, [handleAccept])

  return (
    <>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <div className='container d-flex mt-100px'>
          <div className='w-lg-700px h-lg-400px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto'>
            <div className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'>
              {isLoading ? (
                <div className='d-flex justify-content-center align-items-center h-lg-300px'>
                  <img
                    src={toAbsoluteUrl('/media/gori/orders/reload.gif')}
                    className='w-250px'
                    alt='reload-rate'
                  />
                  <span className='sr-only mt-10'>{intl.formatMessage({id: 'LOADING'})}</span>
                </div>
              ) : isError ? (
                <ActiveError message={messageError} />
              ) : (
                <ActiveSuccess />
              )}
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  )
}

const AcceptTermsUPic = () => {
  return (
    <Routes>
      <Route element={<AcceptTermUPicLayout />}>
        <Route index element={<TermsAcceptComponent />} />
      </Route>
    </Routes>
  )
}

export {AcceptTermsUPic}
